module.exports = __webpack_public_path__ + "static/media/Laidley Street, San Francisco, CA2.04f2dcaf.jpg";